(() => {
  function initDiscountScript() {
    const container = document.getElementById('discount-code-container');
    if (!container || container.dataset.init === '1') return; // garde anti doublon
    container.dataset.init = '1';

    const $applied = document.getElementById('applied-discounts');
    const $btn     = document.getElementById('apply-discount-btn');
    const $input   = document.getElementById('discount-input');
    if (!$applied || !$btn || !$input) return;

    const $err = document.getElementById('discount-error-message');
    const showErr  = m => { if ($err){ $err.style.display='block'; $err.textContent=m; } };
    const clearErr = () => { if ($err){ $err.style.display='none'; $err.textContent=''; } };

    // --- ROOT robuste (gère /fr/, /fr-fr/, etc.) ---
    function getRoot() {
      const r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      if (r !== '/') return r; // ex: "/fr/"
      const m = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-zA-Z]{2})?)\//);
      return m ? `/${m[1]}/` : '/';
    }
    function buildUrl(pathAndQuery) {
      const root = getRoot().replace(/\/+$/,'/');           // "/fr/"
      const path = String(pathAndQuery).replace(/^\//,'');  // "discount/..." ou "discounts/clear?..."
      return new URL(root + path, window.location.origin).toString();
    }

    function reopenDrawer() {
      document.querySelector('mini-cart-popup')?.open?.();
      document.querySelector('cart-drawer')?.open?.();
      window.Cart?.renderAndOpenMiniCartPopup?.();
    }

    const getCodes = () =>
      Array.from($applied.querySelectorAll('.discount-pill'))
        .map(p => (p.getAttribute('data-code') || '').trim())
        .filter(Boolean);

    // Applique la liste exacte de codes
    function applyCodes(codes) {
      sessionStorage.setItem('openCartAfterRedirect', '1');
      const redirect = location.pathname + location.search;
      const url = buildUrl('discount/' + encodeURIComponent(codes.join(',')) +
                           '?redirect=' + encodeURIComponent(redirect));
      window.location.assign(url);
    }

    // ✅ Retirer : écraser par un code invalide
    function clearCodes() {
      sessionStorage.setItem('openCartAfterRedirect', '1');
      const redirect = location.pathname + location.search;
      const url = buildUrl('discount/' + encodeURIComponent('__clear__') +
                           '?redirect=' + encodeURIComponent(redirect));
      window.location.assign(url);
    }

    // Appliquer (clic + touche Enter)
    $btn.addEventListener('click', () => {
      clearErr();
      const val = ($input.value || '').trim();
      if (!val) return showErr('Veuillez entrer un code promo.');
      const newCodes = val.split(',').map(s => s.trim()).filter(Boolean);
      const existing = getCodes().map(c => c.toUpperCase());
      const uniq = [...new Set([...existing, ...newCodes.map(c => c.toUpperCase())])];
      if (uniq.length === existing.length) return showErr('Ce code est déjà appliqué.');
      applyCodes(uniq);
    });
    $input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); $btn.click(); }
    });

    // Retirer une pastille
    $applied.addEventListener('click', (e) => {
      const btn = e.target.closest('.remove-discount');
      if (!btn) return;
      clearErr();
      const pill = btn.closest('.discount-pill');
      const code = pill?.getAttribute('data-code');
      if (!code) return;
      const remain = getCodes().filter(c => c.toUpperCase() !== code.toUpperCase());
      remain.length ? applyCodes(remain) : clearCodes();
    });

    // Au retour de /discount/..., rouvrir le drawer
    if (sessionStorage.getItem('openCartAfterRedirect') === '1') {
      sessionStorage.removeItem('openCartAfterRedirect');
      setTimeout(reopenDrawer, 150);
    }
  }

  document.addEventListener('DOMContentLoaded', initDiscountScript);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, initDiscountScript);
  }
})();